import { Box, Container, Grid, Link, makeStyles, Theme, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { ArrowOfferCardIcon } from 'svgs';
import { ImageBlog } from 'images/blog';

interface HeroSectionBlogProps {
  bgImage: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    backgroundImage: `url(${ImageBlog})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  container: {
    paddingBottom: 140,
    paddingTop: theme.spacing(20),
    minHeight: 'auto',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(28),
      minHeight: '100vh',
    },
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
  },
  arrow: {
    transform: 'rotate(180deg)',
    marginRight: theme.spacing(4),
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  back: {
    color: theme.palette.common.white,
  },
}));

const HeaderSingleBlog: FC<HeroSectionBlogProps> = ({ bgImage }) => {
  const classes = useStyles({ bgImage });
  return (
    <Box className={classes.wrapper}>
      <Container fixed>
        <Grid container className={classes.container}>
          <Grid item sm={12} className={classes.breadcrumb}>
            <ArrowOfferCardIcon className={classes.arrow} />
            <Link href="/blog" className={classes.link}>
              <Typography variant="body1" className={classes.back}>
                Back to blogs
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeaderSingleBlog;
